<template>
  <div>
    <CCard>
      <CCardBody>
        <router-view v-if="isPortSelected" />
        <div v-else>
          <CCardTitle>
            <h1 class="mb-4">List Ports</h1>
          </CCardTitle>
          <div>
            <div class="filters">
              <CSelect
                label="Country"
                :value.sync="countryField.value"
                @update:value="() => { this.getPortData() }"
                :options="countryChoices"
                placeholder="Please select a country"
                size=""
                custom
                horizontal />
            </div>

            <PortTable
              :loading="loading"
              :items="items"
              :fields="fields"
              :pagination="false"
              :table-filter="true"
              :active-page="currentPage"
              @edit="handleEditPort">
            </PortTable>

            <CPagination
              v-show="totalPages > 1"
              :activePage.sync="currentPage"
              :pages="totalPages" />

          </div>
        </div>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import getNested from 'lodash-es/get'
import sortBy from 'lodash-es/sortBy'
import { mapActions } from 'vuex'
import PortTable from './../components/PortTable'
import {
  countryList,
} from '@/constants'


export default {
  name: 'list-ports',

  components: {
    PortTable,
  },

  data() {
    return {
      loading: false,
      apiPageSize: 1000,
      offset: 0,

      pageSize: 50,
      currentPage: 1,
      countryField: {
        value: '',
      },

      items: [],
      fields: [
        { key: 'portId', label: 'Port ID' },
        { key: 'portName', label: 'Port Name' },
        { key: 'countryCode', label: 'Country Code' },
        { key: 'region', label: 'Region' },
        { key: 'unlocode', label: 'Unlocode' },
        {
          key: 'edit',
          label: 'Edit',
          sorter: false,
          filter: false,
          _classes: 'text-center',
        },
      ],
    };
  },

  async mounted() {
    await this.getPortData();
  },

  methods: {
    ...mapActions(
      'polygons', [
        'listPorts',
      ]
    ),

    login() {
      // this.$auth.loginWithRedirect();
    },

    async getPortData(append) {
      this.loading = true;
      let data = await this.listPorts({
        country_code: this.countryField.value,
        next_page_token: this.offset,
        page_size: this.apiPageSize,
      });

      if(append) {
        this.items = this.items.concat(getNested(data, 'ports', []));
      } else {
        this.items = getNested(data, 'ports', []);
      }

      this.loading = false;
    },

    handleEditPort(port) {
      document.querySelector('.c-body').scrollTop = 0;

      this.$router.push({
        name: 'Port Details',
        params: { port_id: port.portId }
      });
    },
  },

  computed: {
    isPortSelected() {
      return this.$route.name === 'Port Details';
    },

    countryChoices() {
      const countries = countryList.map(item => ({
        value: item.country_code,
        label: item.country_name,
      }));
      return sortBy(countries, 'label');
    },

    totalPages () {
      return Math.ceil((this.items.length)/ this.pageSize) || 1
    },
  },

  watch: {
    currentPage: async function (value) {
      if(value * this.pageSize >= this.offset) {
        this.offset += this.apiPageSize;
        await this.getPortData(true);
      }
    }
  },
};
</script>

<style scoped lang="scss">
  .filters {
    display:flex;
    justify-content: flex-end;
  }
</style>
